export default __webpack_public_path__ + "static/media/Fiche Loyal.8fd30249.pdf";